import React, { useState, Component } from "react";
import TimeSlot from "../../components/ServiceRequestForm/TimeSlot";
import "./ScheduleWalkthroughComponent.scss";
// import Logo from "./logonew.png";
import { CalendlyEventListener, InlineWidget } from "react-calendly";
import ServiceRequestTimeslotPicker from "./ServiceRequestTimeslotPicker";
import Avatar from "../../components/Avatar/Avatar";
import { connect } from "react-redux";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import { selectValidation } from "../../store/selectors/Validation";
import { selectFormLoader } from "../../store/selectors/FormLoader";
import { fetchAvailableServiceTimes, clearAvailableServiceTimes } from "../../store/actions/availableServiceTimes";
import { bindActionCreators } from "redux";
import * as client from '../../services/client';
import Loader from "../../components/Loader";
import { clearValidation } from "../../store/actions/suites";
import Button from "../../components/Button";
import Row from "../../components/Row";
import Col from "../../components/Col";
import { variables } from "../../Tenants";
import moment from "moment";

class ServiceRequestScheduling  extends Component {

  state = {
    slotSelected: false,
    scheduling_url: '',
    isLoading: false,
    scheduledAt: null
  }
  componentDidMount () {
    const { serviceRequest, onClearAvailableServiceTimes } = this.props;    
      onClearAvailableServiceTimes();
      this.setState({ isLoading: true })
        client.fetchCalendlyLink(serviceRequest.serviceProvider.email).then(response => {
          if (response.ok || response.status === 200) {
              response.json().then(responseJson => {
                if(responseJson.statusCode === 200) {
                  if(responseJson && responseJson.data && responseJson.data.calendarLink && responseJson.data.calendlyAPIKey) {                                        
                    this.setState({ scheduling_url: responseJson.data.calendarLink, isLoading: false})
                  } else {
                    this.setState({ scheduling_url: '', isLoading: false})
                  }
                } else if(responseJson.statusCode === 400) {
                  this.setState({ scheduling_url: '', isLoading: false})
                } 
              })
           } else {
            this.setState({ scheduling_url: '', isLoading: false})
           }
          })
      // this.setAvailableServiceTimes(serviceRequest.serviceProvider.id);
  }
  setAvailableServiceTimes(contactId) {
    const { onFetchAvailableServiceTimes, serviceRequest} = this.props;
    const servicePreferences = [];
    let theme = localStorage.getItem('theme');
    if(theme === 'Albaster') {
      serviceRequest.preferredServiceTimes.forEach(s => {
        s.slots.forEach(slot => {
          if(slot === '7:30 - 11:30') {
            servicePreferences.push(s.day + ":" + '7am-11am')
          } else if(slot === '11:30 - 3:30') {
            servicePreferences.push(s.day + ":" + '11am-3pm')
          } else {
            servicePreferences.push(s.day + ":" + 'all day')
          }
        })
    });
     onFetchAvailableServiceTimes(contactId, servicePreferences.join(","));
    } else {
    serviceRequest.preferredServiceTimes.forEach(s => {
        s.slots.forEach(slot => {
          servicePreferences.push(s.day + ":" + slot.split(" ", 1))
        })
    });
    onFetchAvailableServiceTimes(contactId, servicePreferences.join(","));
  }
  }

  selectTimeSlot(selectedState) {
    const { serviceRequest, onFetchAvailableServiceTimes } = this.props;
    const servicePreferences = [];
    let theme = localStorage.getItem('theme');
    if(theme === 'Albaster') {    
    let selectedSlots = selectedState.split(',')
    selectedSlots.map(slot => {
      let slots = slot.split(" ");    
      if(slot.includes('7:30 - 11:30')) {
        servicePreferences.push(slots[0] + ":" + '7am-11am')
      } else if(slot.includes('11:30 - 3:30')) {
        servicePreferences.push(slots[0] + ":" + '11am-3pm')
      } else {
        servicePreferences.push(slots[0] + ":" + 'all day')
      }
    })
     onFetchAvailableServiceTimes(serviceRequest?.serviceProvider?.id,servicePreferences);
     this.setState({ slotSelected : true })
    } else {
      const servicePreferences = [];
      var array = selectedState.split(',');
      array.map(slot => {
        let slots = slot.split(" ");
        servicePreferences.push(slots[0] + ":" + slots[1]);
      })
     onFetchAvailableServiceTimes(serviceRequest?.serviceProvider?.id,servicePreferences);
      this.setState({ slotSelected : true })
  }
  }

  componentDidUpdate(){
    const { validation, onClose, clearValidation } = this.props;
    if(validation.status === true) {  
      if(validation.message === 'Schedule') {
        onClose();
        clearValidation();
      }
    }
  }
  render () {
      const { serviceRequest, onClose, onEventScheduled, availableServiceTimes, loader } = this.props;
    return (
      <>
        <div className="header">
          {/* <div className="logo">
          <a href="#.">
            <img src={Logo} alt="" />
          </a>
        </div> */}
        
          <div className="top_coner_box">
            <div className="close_icon" onClick={onClose}>
              <svg
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22 0.125C9.8125 0.125 0.125 9.8125 0.125 22C0.125 34.1875 9.8125 43.875 22 43.875C34.1875 43.875 43.875 34.1875 43.875 22C43.875 9.8125 34.1875 0.125 22 0.125ZM30.4375 32.9375L22 24.5L13.5625 32.9375L11.0625 30.4375L19.5 22L11.0625 13.5625L13.5625 11.0625L22 19.5L30.4375 11.0625L32.9375 13.5625L24.5 22L32.9375 30.4375L30.4375 32.9375Z"
                  fill="#797979"
                />
              </svg>
            </div>
            <svg
              width="156"
              height="201"
              viewBox="0 0 156 201"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                opacity="0.11"
                cx="170"
                cy="31"
                r="135"
                stroke="#48C1BF"
                strokeWidth="70"
              />
            </svg>
          </div>
          
        </div>
  
        <div className="walkthrough_section WalkthroughScroll" style={{width:'98%'}}>
          <div className="wrapper">
            <div className="walthrough_box">
              <div className="title_heading text-center">
                <h2>Schedule Service Request</h2>
              </div>
              <div className="walthrough_table_box">
                <table>
                  <thead>
                    <tr>
                      <th>Property Name</th>
                      <th className="line_table">
                        <div className="line_table_line"></div>
                      </th>
                      <th>Property Address</th>
                      <th className="line_table">
                        <div className="line_table_line"></div>
                      </th>
                      <th>{variables.Suite} </th>
                      <th className="line_table">
                        <div className="line_table_line"></div>
                      </th>
                      <th>Home Owner</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td data-title="Property Name">{serviceRequest?.suite?.property?.name}</td>
                      <td className="line_table">
                        <div className="line_table_line"></div>
                      </td>
                      <td data-title="Property Address">
                        <p>
                          {serviceRequest?.suite?.property?.propertyAddress?.addressLine1 +
                            ", " +
                            serviceRequest?.suite?.property?.propertyAddress?.city +
                            " " +
                            serviceRequest?.suite?.property?.propertyAddress?.postalCode}{" "}
                        </p>
                      </td>
                      <td className="line_table">
                        <div className="line_table_line"></div>
                      </td>
                      <td data-title="Suite">{serviceRequest?.suite?.number}</td>
                      <td className="line_table">
                        <div className="line_table_line"></div>
                      </td>
                      <td data-title="Home Owner">
                        <div className="profile_box">
                          <Avatar url={serviceRequest?.suite?.homeOwner?.profileImage}/>
                          <span style={{marginLeft:"5px"}}>
                            {serviceRequest?.suite?.homeOwner?.name}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {this.state.isLoading || loader ? <Loader center={true}/> :
              <div className="preferred_appointment_times">
                <div className="title text-center">
                  <h3>Preferred appointment times</h3>
                </div>
                  <div className="calender_box">
                    {this.state.scheduling_url ? (
                      <div className="walkthroughTimeSlot walkthroughTimeSlot1">
                        <Row>
                          <Col
                            xs="12"
                            md="6">
                            <TimeSlot
                              fromScheduling={this.props.serviceRequest.preferredServiceTimes}
                              handleSelectionFormData={(selectedState) =>
                                this.selectTimeSlot(selectedState)
                              }
                            />
                          </Col>
                          <Col xs="12"
                            md="6">
                            <CalendlyEventListener
                              onEventScheduled={(
                                e
                              ) => {
                                let uri = e.data.payload?.event.uri;
                                let eventId = uri.split("/").pop();
                                onEventScheduled({ name: 'Scheduled', EventId: eventId });
                              }}
                            >
                              <div
                                style={{
                                  height: "85vh",
                                  width: "50vw",
                                  backgroundColor: "#fbfcfd",
                                }}
                              >
                                <iframe
                                  src={
                                    this.state.scheduling_url +
                                    `?embed_domain=tcampb.github.io&embed_type=Inline&name=${
                                    serviceRequest?.suite?.property?.propertyManagers[0].name
                                    }&email=${serviceRequest?.suite?.property?.propertyManagers[0].email}`
                                  }
                                  width="100%"
                                  height="100%"
                                  frameBorder="0"
                                />
                              </div>
                            </CalendlyEventListener>
                          </Col>
                        </Row>
                      </div>
                  ) 
                  : 
                  //!this.state.slotSelected? (
                    <>
                      <div className="walkthroughTimeSlot" style={{display: 'flex'}}>
                    <TimeSlot
                    from = 'srscheduling'
                    fromScheduling = {this.props.serviceRequest.preferredServiceTimes}
                      handleSelectionFormData={(selectedState) =>
                        this.selectTimeSlot(selectedState)
                      }
                        />
                        <div style={{marginLeft: 20}}> 
                        {!this.state.slotSelected ? <></> :
                        <ServiceRequestTimeslotPicker availableServiceTimes={availableServiceTimes} setFormData={(e)=> this.setState({scheduledAt: e?.scheduledAt})} />
  }</div>
                        </div>
                         <div style={{ textAlign: "center", marginTop: "20px" }}>
                         <Button label="Schedule" color="teal" size="small" 
                         disabled={!this.state.scheduledAt}
                         onClick ={(e)=>onEventScheduled({name: 'Scheduled', scheduledAt: this.state.scheduledAt})}/>
                       </div> 
                       </>
                 // ) : <ServiceRequestTimeslotPicker availableServiceTimes={availableServiceTimes} setFormData={(e)=>onEventScheduled({name: 'Scheduled', scheduledAt: e?.scheduledAt})} />
                  }
                </div>
              </div>}
            </div>
          </div>
        </div>
      </>
    );
  }
};


const mapStateToProps = (state, ownProps) => {
  return {
    user:selectAuthenticatedUser(state),
    availableServiceTimes: state.availableServiceTimes,
    validation: selectValidation(state),
    loader: selectFormLoader(state)
  }
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchAvailableServiceTimes: fetchAvailableServiceTimes,
  onClearAvailableServiceTimes:clearAvailableServiceTimes,
  // onSaveScheduledAppointment: saveScheduledAppointment,
  // // onFetchContacts: fetchContacts,
  // onFetchServiceProviders: fetchServiceProviders,
  clearValidation: clearValidation
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestScheduling);
